var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/ClientError/ClientError.tsx",
  _this = this;
import React from 'react';
import classNames from 'classnames';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { withWebAssetsTheme } from '../../theme';
import useStyles from './useStyles';
// Exported as a named-component for use without ThemeProvider
export var ClientError = function ClientError(_ref) {
  var openingMessage = _ref.openingMessage,
    errorTitle = _ref.errorTitle,
    _ref$titularElementTa = _ref.titularElementTag,
    titularElementTag = _ref$titularElementTa === void 0 ? 'p' : _ref$titularElementTa,
    _ref$fullscreen = _ref.fullscreen,
    fullscreen = _ref$fullscreen === void 0 ? true : _ref$fullscreen,
    children = _ref.children,
    className = _ref.className,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'ClientError' : _ref$dataTestid;
  var _useStyles = useStyles({
      fullscreen: fullscreen
    }),
    wrapper = _useStyles.wrapper,
    innerWrapper = _useStyles.innerWrapper,
    title = _useStyles.title,
    outerBox = _useStyles.outerBox,
    content = _useStyles.content;
  return /*#__PURE__*/React.createElement(Box, {
    className: wrapper,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(innerWrapper, className),
    "data-testid": dataTestId,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageTitle",
    align: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }, openingMessage), /*#__PURE__*/React.createElement(Box, {
    p: 6,
    mt: 6,
    className: outerBox,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    component: titularElementTag,
    variant: "sectionTitle",
    align: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: title,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 13
    }
  }, errorTitle)), /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    variant: "body",
    align: "center",
    color: "darkMuted",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: content,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 13
    }
  }, children)))));
};
export default withWebAssetsTheme(ClientError);
//# sourceMappingURL=ClientError.js.map